<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="companyUpdate" @submit="submit" :updateData="updateData"></UPDATE>

    <UPDATE ref="productUpdate" @submit="submitProduct" :updateData="productUpdate"></UPDATE>

  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/merchandiser/util/url'
import UPDATE from '@/components/page/update'


let symbolType = {2:"外汇",3:"参考行情",4:"商品",5:"期指",6:"货币",7:"股票"}
let symbolField = [];


export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },
  mounted() {

  },
  methods: {
    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if ('新增' == clickName) {
        this.$refs.companyUpdate.open()
      }
    },
    bthClick(clickName, row) {
      if (clickName == 'product') {//查看信号源交易详情
        this.product(row)
      } else if (clickName == 'edit') {//编辑允许跟单产品
        this.edit(row)
      } else if (clickName == 'del') {//移除信号源
        this.del(row)
      }
    },
    product(row) {
      this.dataChange(Url.company.companyProduct, {"companyId":row.companyId }, res => {
        if (res.code == 0) {
          row.symbols = res.result
          this.productUpdate.cols = [
            { title: '公司名称', field: 'name', required: true, readonly: true },
            { title: '公ID', field: 'companyId', isNumber: true, required: true, readonly: true },
            { title: '支持平台', field: 'businessTypes', required: true, readonly: true },
            { title: '产品类型', field: 'symbolType',type:3,optionList:symbolType,button:true, required: true },
          ]
          console.info( res.result)
          for (let i in res.result) {
            let optionList = [];
            const symbolArr =res.result[i];
            for (let j in symbolArr) {
              optionList.push({"symbol":symbolArr[j]})
            }
            console.info(optionList)
            let field = 'product'+i;
            symbolField.push(field);
            let col = {title: symbolType[i], field: field, type: 18, pageData: {
                selection: false,
                isPage: false,
                cols: [
                  {title: '产品', field: 'symbol'},
                ]
              },optionList:optionList,data:[],hidden:(model,col)=>{
                return model.symbolType != i;
              }
            };
            this.productUpdate.cols.push(col);
          }
          this.$refs.productUpdate.open(row)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    edit(row) {
      this.$refs.companyUpdate.open(row)
    },
    del(row) {
      this.dataChange(Url.company.companyDel, row, res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    submit(model) {
      this.dataChange(Url.company.companyEdit, model, res => {
        if (res.code == 0) {
          this.$refs.companyUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    submitProduct(model) {
      this.dataChange(Url.company.companyProductSyn, model, res => {
        if (res.code == 0) {
          this.$refs.productUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  data() {
    return {
      queryData: {},
      updateData: {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          { title: '公司名称', field: 'name', required: true },
          { title: '公司ID', field: 'companyId', isNumber: true, required: true},
          { title: '业务', field: 'businessTypes', required: true }
        ]
      },
      productUpdate: {
        cols: [
          { title: '公司名称', field: 'name', required: true, readonly: true },
          { title: '公司ID', field: 'companyId', isNumber: true, required: true, readonly: true },
          { title: '業務類型', field: 'businessTypes', required: true, readonly: true },
          { title: '产品类型', field: 'symbolType',type:3,optionList:symbolType,button:true, required: true },
        ]
      },
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { click: window.$t('common.search') },
          { click: '新增', auth: 'signal:company:add' }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.company.companyList,
        selection: false,
        sequence: true,
        method: 'get',
        cols: [
          { title: '公司名称', field: 'name' },
          { title: '公司ID', field: 'companyId' },
          { title: '业务', field: 'businessTypes' },
          { title: 'symbols', field: 'symbols' },
          { title: '操作人', field: 'createUser' },
          {
            title: '时间', field: 'createTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '操作',
            btnClick: [
              {
                name: '關聯產品',
                click: 'product',
                type: 'primary',
                icon: 'el-icon-add',
                auth: 'company:product:add'
              },
              {
                name: '編輯',
                click: 'edit',
                type: 'primary',
                icon: 'el-icon-delete',
                auth: 'signal:company:edit'
              },
              {
                name: '移除',
                click: 'del',
                type: 'primary',
                icon: 'el-icon-delete',
                auth: 'signal:company:del'
              }]
          }
        ]
      }
    }
  }
}
</script>
